export type ToastLevel = 'success' | 'info' | 'warning' | 'danger';

export interface ToastOptions {
  level?: ToastLevel;
  durationMs?: number;
}

const CONTAINER_ID = 'acteaze-toast-container';

function ensureContainer(): HTMLElement {
  let container = document.getElementById(CONTAINER_ID);
  if (!container) {
    container = document.createElement('div');
    container.id = CONTAINER_ID;
    container.className = 'toast-container position-fixed top-0 end-0 p-3';
    container.style.zIndex = '1080';
    document.body.appendChild(container);
  }
  return container;
}

export function showToast(message: string, options: ToastOptions = {}): void {
  const level: ToastLevel = options.level ?? 'info';
  const duration = options.durationMs ?? 10000;
  const container = ensureContainer();

  const toast = document.createElement('div');
  toast.className = `toast align-items-center text-bg-${level} border-0 show`;
  toast.setAttribute('role', 'alert');
  toast.setAttribute('aria-live', 'assertive');
  toast.setAttribute('aria-atomic', 'true');
  toast.innerHTML = `
    <div class="d-flex">
      <div class="toast-body"></div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" aria-label="Close"></button>
    </div>`;
  const body = toast.querySelector<HTMLDivElement>('.toast-body')!;
  body.textContent = message;

  const close = (): void => { toast.remove(); };
  toast.querySelector('button')!.addEventListener('click', close);
  container.appendChild(toast);
  window.setTimeout(close, duration);
}
